import React from 'react';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import * as Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
class PlanPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultIndex1: 0,
      defaultIndex2: 0,
      modalIsOpenPlainPage: false,
      modalIsOpenPlainPage1: false,
      price: 0,
      price1: 0,
    };
    this.onItemClick = this.onItemClick.bind(this);
    this.closeModalPrice = this.closeModalPrice.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSelect1 = this.handleSelect1.bind(this);
    this.openModalPlainPage = this.openModalPlainPage.bind(this);
    this.openModalPlainPage1 = this.openModalPlainPage1.bind(this);
    this.closeModalPlainPage = this.closeModalPlainPage.bind(this);
    this.closeModalPlainPage1 = this.closeModalPlainPage1.bind(this);
  }

  onItemClick(id, selectedPlanAmount, planData) {
    // localStorage.setItem('selectedPlanAmount', selectedPlanAmount);
    if (planData.planPriceDto[0].connectFusebill === 0) {
      localStorage.setItem('paymentStatus', 'paid');
    }

    this.props.onPlanSelect(id, selectedPlanAmount, planData);
    this.setState({
      modalIsOpenPlainPage1: false,
      modalIsOpenPlainPage: false,
    });
  }

  closeModalPrice(e) {
    e.preventDefault();
    this.setState({
      modalIsOpenPlainPage1: false,
      modalIsOpenPlainPage: false,
    });
  }

  // handleSelect(key) {
  //   this.setState({ key });
  // }
  getTotalEinForCharge = function () {
    return (Number.parseInt(this.props.totalTaxId, 10) > 250) ? 250 : Number.parseInt(this.props.totalTaxId, 10);
  }

  closeModalPlainPage() {
    this.setState({ modalIsOpenPlainPage: false });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  openModalPlainPage() {
    this.setState({ modalIsOpenPlainPage: true });
  }

  openModalPlainPage1() {
    this.setState({ modalIsOpenPlainPage1: true });
  }

  closeModalPlainPage1() {
    this.setState({ modalIsOpenPlainPage1: false });
  }

  handleSelect() {
    // this.setState({
    //   price:key
    // })
  }

  handleSelect1() {
    // this.setState({
    //   price1:key
    // })

  }

  subscriptionPrice(subscriptionFees, totalTaxId, discount, term) {


    // Max cost is 250 per month based on number of EIN's. The first EIN is included
    // let totalTax = totalTaxId;
    // if (totalTaxId > 1) {
    //   totalTax = totalTaxId - 1;
    // } else {
    //   totalTax = totalTaxId;
    // }
    let subscriptionAmount = '';
    let monthly = (parseFloat(totalTaxId) * 1);
    if (monthly > 250) monthly = 250;
    // console.log('ssssssssssssssssssss', subscriptionFees, totalTaxId, monthly * discount * term, discount, term)

    subscriptionAmount = (subscriptionFees + (monthly * discount * term));
    return subscriptionAmount.toFixed(2);
  }

  render() {
    const {
      defaultIndex1, defaultIndex2, price, price1,
    } = this.state;
    const { plainDetail, enterpriseType, makeitAutomatic } = this.props;
    let plainInfo = [];
    let plainPriceDtoSmall = [];
    let plainPriceDtoSmallEnterprise = [];

    if (plainDetail !== undefined) {
      if (plainDetail.records !== undefined) {
        plainInfo = plainDetail.records;

        if (plainDetail.records.Small[0].planPriceDto !== undefined && plainDetail.records.Small.length > 0) {
          plainPriceDtoSmall = plainDetail.records.Small;
          // plainPriceDtoSmallB = plainDetail.records.Small
          // console.log("AllPlansForMember data", plainPriceDtoSmall)
        }
        if (plainDetail.records.Enterprise[0].planPriceDto !== undefined && plainDetail.records.Enterprise.length > 0) {
          plainPriceDtoSmallEnterprise = plainDetail.records.Enterprise;
          // console.log("AllPlansForMember data", plainPriceDtoSmallEnterprise)

          // plainPriceDtoSmallB = plainDetail.records.Small
        }
      }
    }
    return (
      <span>

        <Modal
          shouldCloseOnOverlayClick={false}

          isOpen={this.state.modalIsOpenPlainPage}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalPlainPage}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
        >
          <div className="modal-content addvehicle-content">


            <div className="col s12">
              <div className="grey-box ">
                <div className="grey-inner center-align">
                  {/*  <p> Would you like to upgrade your subscription for free to our &#x0007B; Premium Basic - from config &#x0007D; . Pay just {(plainPriceDtoSmall!==undefined && plainPriceDtoSmall.length>0 )?(plainPriceDtoSmall[3].planPriceDto[0].partnerFundCommissionType==="Amount")?"$":"":""} {(plainPriceDtoSmall!==undefined && plainPriceDtoSmall.length>0 )?plainPriceDtoSmall[3].planPriceDto[0].fundCommission:""} {(plainPriceDtoSmall!==undefined && plainPriceDtoSmall.length>0 )?(plainPriceDtoSmall[3].planPriceDto[0].partnerFundCommissionType!=="Amount")?"%":"":""} commission on recovered settlement funds with unlimited enrollments. If you want to save env more, consider one of our subscription options ?</p> */}
                  <p>Your choice of the BASIC PLAN includes 3 filed claims per entity.</p>
                  <p>
                    You can also choose to have Collectively file an unlimited number of claims per entity with
                      {' '}
                    <span className="txt-underline">no up-front cost</span>
                    . We will keep
                      {' '}
                    {plainPriceDtoSmall[0] !== undefined ? plainPriceDtoSmall[0].planPriceDto[0].fundCommission : '19.95'}
                    % of collected funds.
                      {' '}
                  </p>
                  <p>
                    Would you like Collectively to automatically file an unlimited number of claims on your behalf?
                      {' '}

                  </p>
                  <button
                    onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[3].planPriceDto[0].planPriceId : '',
                      (plainPriceDtoSmall[0] !== undefined ? plainPriceDtoSmall[0].planPriceDto[0].fundCommission : '19.95'),
                      plainPriceDtoSmall[3])}
                    className="btn waves-effect waves-light primary-btn col s12 m6 Modal-button-Plain offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Yes

                    </button>

                  <button
                    onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[0].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmall[0])}
                    className="btn grey-btn waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    No

                    </button>
                  <br />
                  <a href="" onClick={this.closeModalPrice} className="">
                    Go back to pricing page.
                    </a>
                </div>
              </div>
            </div>

          </div>
        </Modal>
        <Modal
          shouldCloseOnOverlayClick={false}

          isOpen={this.state.modalIsOpenPlainPage1}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalPlainPage1}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
        >
          <div className="modal-content addvehicle-content">


            <div className="col s12">
              <div className="grey-box ">
                <div className="grey-inner center-align">
                  <p>Your choice of the BASIC PLAN includes 3 filed claims per entity.</p>
                  <p>
                    You can also choose to have Collectively file an unlimited number of claims per entity with
                      {' '}
                    <span className="txt-underline">no up-front cost</span>
                    . We will keep
                      {' '}
                    {plainPriceDtoSmallEnterprise[0] !== undefined ? plainPriceDtoSmallEnterprise[0].planPriceDto[0].fundCommission : '19.95'}
                    % of collected funds.
                    </p>
                  <p>
                    Would you like Collectively to automatically file an unlimited number of claims on your behalf?
                    </p>
                  <button
                    onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[3].planPriceDto[0].planPriceId : '',
                      (plainPriceDtoSmallEnterprise[0] !== undefined ? plainPriceDtoSmallEnterprise[0].planPriceDto[0].fundCommission : '19.95'),
                      plainPriceDtoSmallEnterprise[3])}
                    className="btn waves-effect waves-light primary-btn col s12 m6 Modal-button-Plain offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Yes
                    </button>

                  <button
                    onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[0].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmallEnterprise[0])}
                    className="btn grey-btn waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    No
                    </button>
                  <br />

                  <a
                    href=""
                    onClick={this.closeModalPrice}
                    className=""
                  >
                    Go back to pricing page.

                    </a>

                </div>

              </div>
            </div>

          </div>
        </Modal>

        <div style={{ display: enterpriseType !== 'E' ? 'block' : 'none' }} className="totalTaxId">
          <div className="plan-page">
            <div className="main-content make-automatic-plan ">
              <div className="row">
                <div className="col s12">
                  <h4 className="center-align pricing-hdr">Small/Medium Business Pricing</h4>
                </div>
              </div>
              <div className="row">
                <div className="col l4 fusion-pricing-table full-boxed-pricing">
                  <div className="panel-wrapper">
                    <div className="panel-container">
                      <div className="fusion-panel">
                        <div className="panel-heading">
                          <h3 className="title-row"><strong className="fw-700">{(plainInfo.Small !== undefined) ? plainInfo.Small[0].planName : ''}</strong></h3>
                          <span className="recommended-magenta" />

                          <p>For companies that want to try out Collectively</p>

                        </div>
                        <div className="panel-body pricing-row valign-wrapper">
                          <div className="price center-align">
                            NO UPFRONT COST
                            </div>
                        </div>
                        <ul className="list-group">

                          <li className="list-group-item normal-row">"VISA/Mastercard claim" filed automatically</li>
                          <li className="list-group-item normal-row">{makeitAutomatic && makeitAutomatic === true ? "Unlimited claim filings" : localStorage.getItem('changePlan') === "false" ? "Up to ten claims per entity" : "Unlimited claim filings"}</li>
                          <li className="list-group-item normal-row">
                            Collectively keeps
                              {' '}
                            {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? plainPriceDtoSmall[0].planPriceDto[0].fundCommission : ''}
                            % of collected funds
                            </li>
                          <li className="list-group-item normal-row">We collect claim forms for all entities</li>
                          <li className="list-group-item normal-row">Personalized dashboard and settlement alerts</li>
                          <li className="list-group-item normal-row">Upgrade at any time</li>

                        </ul>
                        <div className="panel-footer footer-row">
                          <div className="fusion-button-wrapper fusion-aligncenter">
                            {makeitAutomatic && makeitAutomatic === true ? (
                              <a onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[3].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmall[0])} className="fusion-button button-flat fusion-button-round button-large button-custom button-1 btn"><span className="fusion-button-text">Sign Up</span></a>
                            ) : localStorage.getItem('changePlan') === "false" ? (<a onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[0].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmall[0])} className="fusion-button button-flat fusion-button-round button-large button-custom button-1 btn"><span className="fusion-button-text">Sign Up</span></a>
                            ) : (
                                  <a onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[3].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmall[0])} className="fusion-button button-flat fusion-button-round button-large button-custom button-1 btn"><span className="fusion-button-text">Sign Up</span></a>
                                )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col l4 fusion-pricing-table full-boxed-pricing">
                  <div className="panel-wrapper standout">
                    <div className="panel-container">
                      <div className="fusion-panel">
                        <div className="panel-heading">
                          <h3 className="title-row">
                            <strong className="fw-700">
                              {' '}
                              {(plainInfo.Small !== undefined) ? plainInfo.Small[1].planName : ''}
                              {' '}
                            </strong>
                            <br />
                            <span className="recommended-magenta">  Recommended </span>
                          </h3>
                          <p> For companies that want claims filed automatically</p>

                        </div>
                        <div className="panel-body pricing-row">
                          <div className="price price-with-decimal">
                            <span className="currency price-dollarsign">$</span>
                            {(price === 0) ? (plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? (
                              <span>
                                <span className="integer-part">{plainPriceDtoSmall[1].planPriceDto[0].subscriptionFees.toString().split('.')[0]}</span>
                                <sup className="decimal-part">{plainPriceDtoSmall[1].planPriceDto[0].subscriptionFees.toString().split('.')[1]}</sup>
                              </span>
                            ) : 0 : price}
                            <span className="time">/month</span>
                          </div>
                        </div>
                        <ul className="list-group">

                          <li className="list-group-item normal-row">Claims filed automatically by Collectively*</li>
                          <li className="list-group-item normal-row">Unlimited claim filings</li>
                          <li className="list-group-item normal-row">
                            Collectively keeps
                              {' '}
                            {(price === 0) ? (plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? plainPriceDtoSmall[1].planPriceDto[0].fundCommission : 0 : price}
                            % of collected funds
                            </li>
                          <li className="list-group-item normal-row">
                            We collect claim forms for all entities
                            </li>
                          <li className="list-group-item normal-row">
                            Personalized dashboard and settlement alerts
                            </li>
                          <li className="list-group-item normal-row">
                            {' '}
                            Each additional EIN is +$1.00/month
                              <br />
                            {' '}
                            (capped at $250/month)
                              {' '}
                          </li>
                        </ul>
                        <div className="tabs-intro pt-14">choose your payment option</div>
                        <Tabs defaultIndex={defaultIndex1}>
                          <TabList className="tabs tabs-fixed-width">
                            <Tab className="tab"><a>Monthly</a></Tab>
                            <Tab className="tab">
                              <a>
                                1yr
                                  <br />
                                Save 10%
                                </a>

                            </Tab>
                            <Tab className="tab">
                              <a>
                                3yr
                                  <br />
                                Save 15%
                                </a>

                            </Tab>
                            {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? (plainPriceDtoSmall[1].planPriceDto.length === 4) ? (
                              <Tab className="tab">
                                <a>
                                  5yr
                                    <br />
                                  Save 20%
                                  </a>

                              </Tab>
                            ) : '' : ''}

                          </TabList>

                          <TabPanel>
                            <div className="tab-content" id="tab-m">
                              Your Monthly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[0].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 1, 1) : '250'}
                              <br />
                              <p>(plus any contingent fees)</p>
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[1].planPriceDto !== undefined ? plainPriceDtoSmall[1].planPriceDto[0].planPriceId : '' : '',
                                  ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[0].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 1, 1) : '250'),
                                  plainPriceDtoSmall[1])}
                                className="waves-effect btn primary"
                              >
                                <span className="fusion-button-text">Sign Up For Monthly</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-1">
                              Your Yearly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[1].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.9, 12) : '250'}
                              <br />
                              <p>(plus any contingent fees)</p>
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[1].planPriceDto[1].planPriceId : '',
                                  ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[1].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.9, 12) : '250'),
                                  plainPriceDtoSmall[1])}
                                className="waves-effect btn primary"
                              >
                                <span>Sign Up For One Year</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-3">
                              Your 3 Year Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[2].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.85, 36) : '250'}
                              <br />
                              <p>(plus any contingent fees)</p>
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[1].planPriceDto[2].planPriceId : '',
                                  ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[2].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.85, 36) : '250'),
                                  plainPriceDtoSmall[1])}
                                className="waves-effect btn primary"
                              >
                                <span>Sign Up For Three Years</span>
                              </a>
                            </div>
                          </TabPanel>
                          {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? (plainPriceDtoSmall[1].planPriceDto.length === 4) ? (

                            <TabPanel>
                              <div className="tab-content" id="tab-5">
                                Your 5 Year Cost for
                                  {' '}
                                {Number.parseInt(this.props.totalTaxId, 10) + 1}
                                {' '}
                                EINs: $
                                  {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[3].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.8, 60) : '250'}
                                <br />
                                <p>(plus any contingent fees)</p>
                                <a
                                  onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? ((plainPriceDtoSmall[1].planPriceDto.length === 4)) ? plainPriceDtoSmall[1].planPriceDto[3].planPriceId : '' : '',
                                    ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[1].planPriceDto[3].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.8, 60) : '250'),
                                    plainPriceDtoSmall[1])}
                                  className="waves-effect btn primary"
                                >
                                  <span>Sign Up For Five Years</span>
                                </a>
                              </div>
                            </TabPanel>
                          ) : '' : ''}
                        </Tabs>
                        <div className="more-value">MORE Value for LESS</div>
                      </div>
                    </div>
                  </div>
                  <div className="fusion-text">
                    <p><em>*Claims are automatically filed when claims data is readily available. We try to only contact you if additional information is necessary to start the claims process.</em></p>
                  </div>
                </div>
                <div className="col l4 fusion-pricing-table full-boxed-pricing">
                  <div className="panel-wrapper">
                    <div className="panel-container">
                      <div className="fusion-panel">

                        <div className="panel-heading">
                          <h3 className="title-row">
                            <strong className="fw-700">
                              {' '}
                              {(plainInfo.Small !== undefined) ? plainInfo.Small[2].planName : ''}
                            </strong>
                            {' '}
                          </h3>
                          <span className="recommended-magenta" />

                          <p style={{ textAlign: 'center' }}>For companies that want to be more hands-on</p>

                        </div>
                        <div className="panel-body pricing-row">
                          <div className="price price-with-decimal">
                            <span className="currency price-dollarsign">$</span>
                            {(price1 === 0) ? (plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? (
                              <span>
                                <span className="integer-part">{plainPriceDtoSmall[2].planPriceDto[0].subscriptionFees.toString().split('.')[0]}</span>
                                <sup className="decimal-part">{plainPriceDtoSmall[2].planPriceDto[0].subscriptionFees.toString().split('.')[1]}</sup>
                              </span>
                            ) : 0 : price1}
                            <span className="time">/month</span>
                          </div>
                        </div>
                        <ul className="list-group">
                          <li className="list-group-item normal-row">You decide which claims are filed</li>
                          <li className="list-group-item normal-row">Unlimited claim filings</li>
                          <li className="list-group-item normal-row">
                            Collectively keeps
                              {' '}
                            {(price1 === 0) ? (plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? plainPriceDtoSmall[2].planPriceDto[0].fundCommission : 0 : price1}
                            % of collected funds
                            </li>
                          <li className="list-group-item normal-row">We collect claim forms for all entities</li>
                          <li className="list-group-item normal-row">
                            Personalized dashboard and settlement alerts

                            </li>
                          <li className="list-group-item normal-row">
                            Each additional EIN is +$1.00/month
                              <br />
                            {' '}
                            (capped at $250/month)
                            </li>
                        </ul>
                        <div className="tabs-intro pt-14">choose your payment option</div>
                        <Tabs defaultIndex={defaultIndex2} onSelect={defaultIndex2 => this.handleSelect1((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? plainPriceDtoSmall[2].planPriceDto[defaultIndex2].fundCommission : '')}>
                          <TabList className="tabs tabs-fixed-width">
                            <Tab className="tab"><a>Monthly</a></Tab>
                            <Tab className="tab">
                              <a>
                                1yr
                                  <br />
                                Save 10%
                                </a>

                            </Tab>
                            <Tab className="tab">
                              <a>
                                3yr
                                  <br />
                                Save 15%
                                </a>

                            </Tab>
                            <Tab className="tab">
                              <a>
                                5yr
                                  <br />
                                Save 20%
                                </a>

                            </Tab>
                          </TabList>

                          <TabPanel>
                            <div className="tab-content" id="tab-m2">
                              Your Monthly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[0].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 1, 1) : '250'}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[2].planPriceDto[0].planPriceId : '',
                                  ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[0].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 1, 1) : '250'),
                                  plainPriceDtoSmall[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For Monthly</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-12">
                              Your Yearly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[1].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.9, 12) : '250'}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[2].planPriceDto[1].planPriceId : '',
                                  ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[1].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.9, 12) : '250'),
                                  plainPriceDtoSmall[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For One Year</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-32">
                              Your 3 Year Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[2].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.85, 36) : '250'}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[2].planPriceDto[2].planPriceId : '',
                                  ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[2].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.85, 36) : '250'),
                                  plainPriceDtoSmall[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For Three Years</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-52">
                              Your 5 Year Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[3].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.8, 60) : '250'}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmall !== undefined) ? plainPriceDtoSmall[2].planPriceDto[3].planPriceId : '',
                                  ((plainPriceDtoSmall !== undefined && plainPriceDtoSmall.length > 0) ? this.subscriptionPrice(plainPriceDtoSmall[2].planPriceDto[3].subscriptionFees, Number.parseInt(this.props.totalTaxId, 10), 0.8, 60) : '250'),
                                  plainPriceDtoSmall[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For Five Years</span>
                              </a>
                            </div>
                          </TabPanel>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div style={{ display: enterpriseType === 'E' ? 'block' : 'none' }} className="2">
          <div className="plan-page">
            <div className="main-content make-automatic-plan ">
              <div className="row">
                <div className="col s12">
                  <h4 className="center-align pricing-hdr">Enterprise Pricing</h4>
                </div>
              </div>
              <div className="row">
                <div className="col l4 fusion-pricing-table full-boxed-pricing">
                  <div className="panel-wrapper">
                    <div className="panel-container">
                      <div className="fusion-panel">

                        <div className="panel-heading">
                          <h3 className="title-row"><strong className="fw-700">{(plainInfo.Enterprise !== undefined) ? plainInfo.Enterprise[0].planName : ''}</strong></h3>
                          <p>For companies that want to try out Collectively</p>

                        </div>
                        <div className="panel-body pricing-row valign-wrapper">
                          <div className="price center-align">
                            NO UPFRONT COST
                            </div>
                        </div>
                        <ul className="list-group">
                          <li className="list-group-item normal-row">"VISA/Mastercard claim" filed automatically</li>
                          <li className="list-group-item normal-row">{makeitAutomatic && makeitAutomatic === true ? "Unlimited claim filings" : localStorage.getItem('changePlan') === "false" ? "Up to ten claims per entity" : "Unlimited claim filings"}</li>
                          <li className="list-group-item normal-row">
                            Collectively keeps
                              {' '}
                            {(price === 0) ? (plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? plainPriceDtoSmallEnterprise[0].planPriceDto[0].fundCommission : 0 : price}
                            % of collected funds
                            </li>
                          <li className="list-group-item normal-row">We collect claim forms for all entities.</li>
                          <li className="list-group-item normal-row">Personalized dashboard and settlement alerts</li>
                          <li className="list-group-item normal-row">
                            End-to-end claims management


                            </li>
                        </ul>
                        <div className="panel-footer footer-row">
                          <div className="fusion-button-wrapper fusion-aligncenter">
                            {makeitAutomatic && makeitAutomatic === true ? (

                              <a onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[3].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmallEnterprise[0])} className="fusion-button button-flat fusion-button-round button-large button-custom button-1 btn"><span className="fusion-button-text">Sign Up</span></a>
                            ) : localStorage.getItem('changePlan') === "false" ? (
                              <a onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[0].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmallEnterprise[0])} className="fusion-button button-flat fusion-button-round button-large button-custom button-1 btn"><span className="fusion-button-text">Sign Up</span></a>

                            ) : (

                                  <a onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[3].planPriceDto[0].planPriceId : '', 0, plainPriceDtoSmallEnterprise[0])} className="fusion-button button-flat fusion-button-round button-large button-custom button-1 btn"><span className="fusion-button-text">Sign Up</span></a>
                                )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col l4 fusion-pricing-table full-boxed-pricing">
                  <div className="panel-wrapper standout">
                    <div className="panel-container">
                      <div className="fusion-panel">
                        <div className="panel-heading">
                          <h3 className="title-row">
                            <strong className="fw-700">
                              {(plainInfo.Enterprise !== undefined) ? plainInfo.Enterprise[1].planName : ''}
                              {' '}
                            </strong>
                            <br />
                            <span className="recommended-magenta">  Recommended </span>
                          </h3>
                          <p> For companies that want claims filed automatically</p>

                        </div>
                        <div className="panel-body pricing-row">
                          <div className="price price-with-decimal">
                            <span className="currency price-dollarsign">$</span>
                            <span className="integer-part">
                              {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? plainPriceDtoSmallEnterprise[1].planPriceDto[0].subscriptionFees : ''}
                            </span>
                            {' '}
                            <sup className="decimal-part" />
                            <span className="time">/month</span>
                          </div>
                        </div>
                        <ul className="list-group">
                          <li className="list-group-item normal-row">Claims filed automatically by Collectively*</li>
                          <li className="list-group-item normal-row">Unlimited claim filings</li>
                          <li className="list-group-item normal-row">
                            Collectively keeps
                              {' '}
                            {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? plainPriceDtoSmallEnterprise[1].planPriceDto[0].fundCommission : ''}
                            % of collected funds
                            </li>
                          <li className="list-group-item normal-row">We collect claim forms for all entities.</li>
                          <li className="list-group-item normal-row">Personalized dashboard and settlement alerts</li>
                          <li className="list-group-item normal-row">End-to-end claims management</li>
                        </ul>
                        <div className="tabs-intro pt-14">choose your payment option</div>
                        <Tabs defaultIndex={0}>
                          <TabList className="tabs tabs-fixed-width">
                            <Tab className="tab"><a>Monthly</a></Tab>
                            <Tab className="tab">
                              <a>
                                1yr
                                  <br />
                                Save 10%
                                </a>

                            </Tab>
                            <Tab className="tab">
                              <a>
                                3yr
                                  <br />
                                Save 15%
                                </a>

                            </Tab>
                            <Tab className="tab">
                              <a>
                                5yr
                                  <br />
                                Save 20%
                                </a>

                            </Tab>
                          </TabList>

                          <TabPanel>
                            <div className="tab-content" id="tab-m">
                              Your Monthly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? (parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[0].subscriptionFees) * 1).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[1].planPriceDto[0].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? (parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[0].subscriptionFees) * 1).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[1])}
                                className="waves-effect btn primary"
                              >
                                <span className="fusion-button-text">Sign Up For Monthly</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-1">
                              Your Yearly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? (parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[1].subscriptionFees) * 0.9).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[1].planPriceDto[1].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? (parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[1].subscriptionFees) * 0.9).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[1])}
                                className="waves-effect btn primary"
                              >
                                <span>Sign Up For One Year</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-3">
                              Your 3 Year Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[2].subscriptionFees) + 0) * 0.85).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[1].planPriceDto[2].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[2].subscriptionFees) + 0) * 0.85).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[1])}
                                className="waves-effect btn primary"
                              >
                                <span>Sign Up For Three Years</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-5">
                              Your 5 Year Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[3].subscriptionFees) + 0) * 0.8).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[1].planPriceDto[3].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[1].planPriceDto[3].subscriptionFees) + 0) * 0.8).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[1])}
                                className="waves-effect btn primary"
                              >
                                <span>Sign Up For Five Years</span>
                              </a>
                            </div>
                          </TabPanel>
                        </Tabs>
                      </div>
                    </div>
                    <div className="more-value">MORE Value for LESS</div>
                  </div>
                  <div className="fusion-text">
                    <p><em>*Claims are automatically filed when claims data is readily available. We try to only contact you if additional information is necessary to start the claims process.</em></p>
                  </div>
                </div>
                <div className="col l4 fusion-pricing-table full-boxed-pricing">
                  <div className="panel-wrapper">
                    <div className="panel-container">
                      <div className="fusion-panel">
                        <div className="panel-heading">
                          <h3 className="title-row">
                            {' '}
                            <strong className="fw-700">{(plainInfo.Enterprise !== undefined) ? plainInfo.Enterprise[2].planName : ''}</strong>
                            {' '}
                          </h3>
                          <p style={{ textAlign: 'center' }}>For companies that want to be more hands-on</p>

                        </div>
                        <div className="panel-body pricing-row">
                          <div className="price price-with-decimal">
                            <span className="currency price-dollarsign">$</span>
                            <span className="integer-part">{(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? plainPriceDtoSmallEnterprise[2].planPriceDto[0].subscriptionFees : ''}</span>
                            <span className="time">  /month</span>
                          </div>
                        </div>
                        <ul className="list-group">


                          <li className="list-group-item normal-row">You decide which claims are filed</li>
                          <li className="list-group-item normal-row">Unlimited claim filings</li>
                          <li className="list-group-item normal-row">
                            Collectively keeps
                              {' '}
                            {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? plainPriceDtoSmallEnterprise[2].planPriceDto[0].fundCommission : ''}
                            % of collected funds
                            </li>
                          <li className="list-group-item normal-row">We collect claim forms for all entities.</li>
                          <li className="list-group-item normal-row">Personalized dashboard and settlement alerts</li>

                          <li className="list-group-item normal-row">
                            End-to-end claims management
                              <br />
                            {' '}

                          </li>
                        </ul>
                        <div className="tabs-intro pt-14">choose your payment option</div>
                        <Tabs defaultIndex={0}>
                          <TabList className="tabs tabs-fixed-width">
                            <Tab className="tab"><a>Monthly</a></Tab>
                            <Tab className="tab">
                              <a>
                                1yr
                                  <br />
                                Save 10%
                                </a>

                            </Tab>
                            <Tab className="tab">
                              <a>
                                3yr
                                  <br />
                                Save 15%
                                </a>

                            </Tab>
                            <Tab className="tab">
                              <a>
                                5yr
                                  <br />
                                Save 20%
                                </a>

                            </Tab>
                          </TabList>

                          <TabPanel>
                            <div className="tab-content" id="tab-m2">

                              Your Monthly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[0].subscriptionFees) + 0) * 1).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[2].planPriceDto[0].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[0].subscriptionFees) + 0) * 1).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For Monthly</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-12">
                              Your Yearly Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[1].subscriptionFees) + 0) * 0.9).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[2].planPriceDto[1].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[1].subscriptionFees) + 0) * 0.9).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For One Year</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-32">
                              Your 3 Year Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[2].subscriptionFees) + 0) * 0.85).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[2].planPriceDto[2].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[2].subscriptionFees) + 0) * 0.85).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For Three Years</span>
                              </a>
                            </div>
                          </TabPanel>
                          <TabPanel>
                            <div className="tab-content" id="tab-52">
                              Your 5 Year Cost for
                                {' '}
                              {Number.parseInt(this.props.totalTaxId, 10) + 1}
                              {' '}
                              EINs: $
                                {(plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[3].subscriptionFees) + 0) * 0.8).toFixed(2) : ''}
                              <br />
                              <p>(plus any contingent fees)</p>
                              {' '}
                              <a
                                onClick={() => this.onItemClick((plainPriceDtoSmallEnterprise !== undefined) ? plainPriceDtoSmallEnterprise[2].planPriceDto[3].planPriceId : '',
                                  ((plainPriceDtoSmallEnterprise !== undefined && plainPriceDtoSmallEnterprise.length > 0) ? ((parseFloat(plainPriceDtoSmallEnterprise[2].planPriceDto[3].subscriptionFees) + 0) * 0.8).toFixed(2) : ''),
                                  plainPriceDtoSmallEnterprise[2])}
                                className="waves-effect btn"
                              >
                                <span>Sign Up For Five Years</span>
                              </a>
                            </div>
                          </TabPanel>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

export default PlanPage;
